var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBlingAigHeader = function SvgIconBlingAigHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FBBF24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 16s0-8 6-8C6 8 6 0 6 0s0 8-6 8c6 0 6 8 6 8M12 17s0-3 2-3c-2 0-2-3-2-3s0 3-2 3c2 0 2 3 2 3"
  }))));
};
export default SvgIconBlingAigHeader;